import CuratedWaypoints from './CuratedWaypoints';

export default CuratedWaypoints;
